import ability from './ability'

export const canNavigate = to => {
  try {
    // Treat routes without ACL meta as public
    const protectedMatches = to.matched.filter(route => route && route.meta && (route.meta.resource || route.meta.action))
    if (protectedMatches.length === 0) return true

    return protectedMatches.some(route => ability.can(route.meta.action || 'read', route.meta.resource))
  } catch (error) {
    // Swallow errors and deny navigation when ACL evaluation fails
    // Optionally log for debugging:
    console.error('[ACL] canNavigate error:', error)
    return false
  }
}

export const _ = undefined
